export default __webpack_public_path__ + "static/media/SS3Medium.otf.10983911.woff";